var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.data),function(ip){return _c('van-row',{key:ip.id},[_c('van-col',{attrs:{"span":"12"}},[_vm._v(_vm._s(ip.ip))]),_c('van-col',{attrs:{"span":"12"}},[_vm._v(_vm._s(new Date(ip.time).toLocaleString()))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }